import { ScrollTrigger } from "@gsap";

/**
 * Layout: Ons DNA
 * Slug: ons_dna
 */

const initOnsDna = () => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    document.querySelectorAll(".ons_dna-layout").forEach((layout) => {
        const items = [...layout.querySelectorAll(".dna-item.has-more")];
        if (!items.length) return;

        // Opening and closing is pure CSS (grid-template-rows); only the class and aria state toggle here
        const setOpen = (item, open) => {
            const toggle = item.querySelector(".dna-toggle");
            const panel = item.querySelector(".dna-panel");
            if (!toggle || !panel || item.classList.contains("is-open") === open) return;

            item.classList.toggle("is-open", open);
            toggle.setAttribute("aria-expanded", String(open));
            panel.inert = !open;
        };

        // The page height changes, so trigger positions below must be recalculated once the transition is done
        layout.addEventListener("transitionend", (e) => {
            if (e.target.classList.contains("dna-panel") && e.propertyName === "grid-template-rows") {
                ScrollTrigger.refresh();
            }
        });

        items.forEach((item) => {
            item.querySelector(".dna-toggle").addEventListener("click", () => {
                const willOpen = !item.classList.contains("is-open");
                items.forEach((other) => other !== item && setOpen(other, false));
                setOpen(item, willOpen);

                // No transition under reduced motion, so there is no transitionend to wait for
                if (reducedMotion.matches) ScrollTrigger.refresh();
            });
        });
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOnsDna);
} else {
    initOnsDna();
}
